module.exports = __webpack_public_path__ + "img/two-column-grid-help.bdccf4e1.png";